// TODO: rewrite this file to reduce code repetition
import { hostFactory as hostInstance } from "../factory";

const getUsers = companyId =>
  hostInstance.get(`/api/companies/${companyId}/users`);

const addUser = (companyId, user) =>
  hostInstance.post(`/api/companies/${companyId}/users`, user);

const getUserById = (companyId, userId) =>
  hostInstance.get(`/api/companies/${companyId}/users/${userId}`);

const updateUser = ({ companyId, updatedUser, userId }) =>
  hostInstance.put(`/api/companies/${companyId}/users/${userId}`, updatedUser);

const toggleUsers = ({ companyId, userId, toggler }) =>
  hostInstance.patch(`/api/companies/${companyId}/users/${userId}/${toggler}`);

const deleteUser = (companyId, userId) =>
  hostInstance.delete(`/api/companies/${companyId}/users/${userId}`);

// TODO: export it to admin routes
const getUsersAcl = () => hostInstance.get("/api/users/roles");

const getUserProgram = (companyId, userId) =>
  hostInstance.get(`/api/companies/${companyId}/users/${userId}/programs`);

const getUserSchedule = (companyId, userId) =>
  hostInstance.get(`/api/companies/${companyId}/users/${userId}/schedule`);

const getUserRecords = (companyId, userId, date, version) =>
  hostInstance.get(`/api/companies/${companyId}/users/${userId}/records?date=${date}&version=${version}`);

const getUserRecordsDownload = (companyId, userId, date, type, version) => {
  const opts = {
      responseType: 'arraybuffer',
      params: {
        date: date,
        version: version,
        type: type
      }
  };
  return hostInstance.get(`/api/companies/${companyId}/users/${userId}/records/download`, opts);
}

const getUserCertificate = (companyId, userId, hash) =>
  hostInstance.get(`/api/companies/${companyId}/users/${userId}/certificates/${hash}`);

const getUserCertificateDownload = (companyId, userId, hash) =>{
  const opts = {
    responseType: 'arraybuffer'
  };
  return hostInstance.get(`/api/companies/${companyId}/users/${userId}/certificates/${hash}/download`, opts);
}

const getUserEvent = (companyId, userId, eventId) =>
  hostInstance.get(`/api/companies/${companyId}/users/${userId}/event/${eventId}`);

export {
  addUser,
  getUserById,
  deleteUser,
  updateUser,
  toggleUsers,
  getUsersAcl,
  getUsers as getCompanyUsers,
  getUserProgram,
  getUserSchedule,
  getUserRecords,
  getUserRecordsDownload,
  getUserCertificate,
  getUserCertificateDownload,
  getUserEvent
};

export default getUsers;
